import { createFileRoute } from '@tanstack/react-router';
import { ProductsListPage } from '@/modules/products/pages/ProductsListPage';

export const Route = createFileRoute('/dashboard/products/')({
  component: ProductsListPage,
});
